import React, { useRef } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './TestimonialsCarousel.scss';
import { desktopImages } from '../../../../images';

const TestimonialsCarousel = () => {
  const sliderRef = useRef(null);

  const testimonials = [
    {
      id: 1,
      logo: desktopImages.EssentiaPharma,
      comment: "Depois que comecei a fazer meus manipulados na Essentia Pharma, meus resultados melhoraram significativamente. Melhor farmácia de manipulação do país, sem dúvidas!",
      author: "Renata Desordi"
    },
    {
      id: 2,
      logo: desktopImages.Noorskin,
      comment: "Sem dúvidas um dos melhores produtos que já utilizei. Sinto minha pele muito bem nutrida e hidratada durante todo o dia.",
      author: "Laura"
    },
    {
      id: 3,
      logo: desktopImages.EssentialNutrition,
      comment: "Eu amei o café sabor caramelo, uma delícia mesmo, viu? Super aprovado! Inclusive, pensei em indicar a alguns pacientes. Estou gostando muito de tudo da Essential Nutrition.",
      author: "Dra. Fernanda Ribeiro"
    }
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false, // Desabilitamos as setas padrão
    centerMode: false,
    variableWidth: false,
    appendDots: dots => (
      <div className="custom-dots">
        <button
          className="carousel-btn prev-btn"
          onClick={() => sliderRef.current?.slickPrev()}
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
        <ul> {dots} </ul>
        <button
          className="carousel-btn next-btn"
          onClick={() => sliderRef.current?.slickNext()}
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
      </div>
    ),
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  };

  return (
    <div className="testimonials-carousel">
      <div className="testimonials-container">
        <h2 className="testimonials-title">
          Depoimentos que refletem a nossa essência
        </h2>
        <div className="testimonials-content">
          <img 
            src={desktopImages.TestimonialsBackground} 
            alt="Background" 
            className="testimonials-background-image desktop-only"
          />
          <Slider {...settings} ref={sliderRef} className="testimonials-slider">
            {testimonials.map((testimonial) => (
              <div key={testimonial.id} className="testimonial-slide">
                <div className="slide-content">
                  <div className="testimonial-logo">
                    <img
                      src={testimonial.logo}
                      alt="Logo"
                      className="logo-image"
                    />
                  </div>
                  <div className="testimonial-card">
                    <div className="quote-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="36.36" height="29.28" viewBox="0 0 36.36 29.28">
                        <path id="Caminho_1966" data-name="Caminho 1966" d="M16.44-81.24C10.32-76.92,6-69.84,6-62.04c0,6.36,3.84,10.08,8.28,10.08a7.272,7.272,0,0,0,7.32-7.32c0-3.96-2.76-6.84-6.36-6.84a6.8,6.8,0,0,0-1.92.24c.6-4.08,4.44-8.88,8.28-11.28Zm20.64,0c-6,4.32-10.32,11.4-10.32,19.2,0,6.36,3.84,10.08,8.28,10.08a7.349,7.349,0,0,0,7.32-7.32,6.542,6.542,0,0,0-6.48-6.84,5.846,5.846,0,0,0-1.8.24c.6-4.08,4.32-8.88,8.16-11.28Z" transform="translate(-6 81.24)" />
                      </svg>
                    </div>
                    <div className="testimonial-content">
                      <p className="testimonial-text">
                        {testimonial.comment}
                      </p>
                      <span className="testimonial-author">
                        - {testimonial.author}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default TestimonialsCarousel;